module.exports = __webpack_public_path__ + "img/database_bg.2d91a6a8.png";